<template>
  <section class="ai-visibility-question-sources-list">
    <div class="ai-visibility-question-sources-list__heading">
      <h3>Sources AI read</h3>
      <p>Which sites got cited when answering this question</p>
    </div>
    <div v-if="citations.length" class="ai-visibility-question-sources-list__list">
      <div
        v-for="citation in citations"
        :key="citation.domain"
        class="ai-visibility-question-sources-list__row"
      >
        <div class="ai-visibility-question-sources-list__source">
          <source-avatar :domain="citation.domain" />
          <span class="domain">{{ citation.domain }}</span>
          <panel-badge v-if="isTrackedDomain(citation.domain)">Your domain</panel-badge>
        </div>
        <strong>{{ citation.citationCount }}x</strong>
      </div>
    </div>
    <p v-else class="ai-visibility-question-sources-list__empty">
      No cited sources for this question yet.
    </p>
  </section>
</template>

<script>
import SourceAvatar from '../../../ui/display/SourceAvatar.vue'
import PanelBadge from '../../../ui/display/PanelBadge.vue'

export default {
  name: 'QuestionSourcesList',
  components: {
    SourceAvatar,
    PanelBadge,
  },
  props: {
    citations: {
      type: Array,
      default () {
        return []
      },
    },
    trackedDomain: {
      type: String,
      default: '',
    },
  },
  methods: {
    isTrackedDomain (domain) {
      return Boolean(domain && this.trackedDomain && domain === this.trackedDomain)
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-question-sources-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ai-visibility-question-sources-list__heading {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ai-visibility-question-sources-list__heading h3,
.ai-visibility-question-sources-list__heading p {
  margin: 0;
}

.ai-visibility-question-sources-list__heading h3 {
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 700;
}

.ai-visibility-question-sources-list__heading p,
.ai-visibility-question-sources-list__empty {
  color: var(--v-mainColor3-base);
  font-size: 14px;
  line-height: 1.45;
}

.ai-visibility-question-sources-list__list {
  overflow: hidden;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 8px;
  background: var(--v-cardBg-base);
  padding: 0 16px;
}

.ai-visibility-question-sources-list__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-width: 0;
  border-bottom: 1px dashed var(--v-gray12Color-base);
  padding: 12px 0;
}

.ai-visibility-question-sources-list__row:last-child {
  border-bottom: 0;
}

.ai-visibility-question-sources-list__source {
  flex: 1 1 auto;
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.ai-visibility-question-sources-list__source ::v-deep .ai-visibility-source-avatar {
  width: 22px;
  height: 22px;
  flex-basis: 22px;
  font-size: 10px;
}

.ai-visibility-question-sources-list__source .domain {
  overflow: hidden;
  color: var(--v-mainColor-base);
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ai-visibility-question-sources-list__row strong {
  flex: 0 0 auto;
  color: var(--v-mainColor-base);
  font-size: 16px;
}
</style>
